import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgSelectModule } from '@ng-select/ng-select';

import { InfoIconModule } from 'src/app/shared/info-icon/info-icon.module';
import { CandidateJobMatchCardModule } from '../candidate-job-match-card/candidate-job-match-card.module';
import { CandidateJobMatchesWorkflowActionsModalModule } from '../candidate-job-matches-workflow-actions-modal/candidate-job-matches-workflow-actions-modal.module';
import { CandidateSendOutreachEmailModalModule } from '../candidate-send-outreach-email-modal/candidate-send-outreach-email-modal.module';

import { CandidateJobMatchesWorkflowComponent } from './candidate-job-matches-workflow.component';

@NgModule({
  declarations: [CandidateJobMatchesWorkflowComponent],
  imports: [
    CommonModule,
    FormsModule,
    DragDropModule,
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    InfiniteScrollModule,
    NgSelectModule,
    InfoIconModule,
    CandidateJobMatchCardModule,
    CandidateJobMatchesWorkflowActionsModalModule,
    CandidateSendOutreachEmailModalModule
  ],
  exports: [CandidateJobMatchesWorkflowComponent],
  entryComponents: [CandidateJobMatchesWorkflowComponent]
})
export class CandidateJobMatchesWorkflowModule { }
